function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsciugamani(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.993 511.993",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M511.903,53.327C511.903,23.874,488.059,0,458.591,0H53.418C23.981,0,0.106,23.875,0.106,53.312 L0.09,53.328v362.368l511.812,21.655V53.327H511.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M437.279,362.713v-0.078H53.402c-29.437,0-53.312,23.875-53.312,53.312l0,0v85.312l0,0 c0,5.891,4.781,10.656,10.672,10.656l0,0H433.81c1.156,0.062,2.312,0.078,3.469,0.078c41.218,0,74.624-33.406,74.624-74.641 C511.903,396.134,478.497,362.713,437.279,362.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA936"
    },
    d: "M437.279,405.29H53.402l0,0c-0.031,0-0.047,0-0.078,0c-5.891,0-10.671,4.766-10.671,10.656 s4.78,10.671,10.671,10.671c0.031,0,0.047-0.016,0.078-0.016v0.016h353.722h30.155c5.875,0,10.656,4.781,10.656,10.656 s-4.781,10.672-10.656,10.672h-30.155H0.091v21.312h437.188c17.655,0,31.999-14.312,31.999-31.984 C469.278,419.602,454.935,405.29,437.279,405.29z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsciugamani);
export default __webpack_public_path__ + "static/media/asciugamani.4c64e6f69fa28351277d9aee34b01523.svg";
export { ForwardRef as ReactComponent };